import AsyncCallHandler from "../common/AsyncCallHandler";
import ACTION_TYPES from "./actionTypes";
import NEXUS_CONST from "../common/constants";
import { set, get } from "../common/utils";
import executeApiRequest from "../common/executeApiRequest";

export const fetchRailGridData = (dispatch, tier) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_RAIL_GRID + tier, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_PERF_GRID, payload: res.data });
    }
  );
};
export const fetchSitewiseRailGridData = (dispatch, tier) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_RAIL_GRID_SITEWISE + tier,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_PERF_GRID, payload: res.data });
  });
};
export const updateAction = (dispatch, data, tier) => {
  AsyncCallHandler(NEXUS_CONST.UPDATE_ACTION, NEXUS_CONST.POST, data).then(
    (res) => {
      fetchRailGridData(dispatch, tier);
      //dispatch({ type: ACTION_TYPES.FETCH_PERF_GRID, payload: res.data });
    }
  );
};

export const createAction = (dispatch, data, tier) => {
  AsyncCallHandler(NEXUS_CONST.MANAGE_ACTIONS, NEXUS_CONST.POST, data).then(
    (res) => {
      fetchRailGridData(dispatch, tier);
      //dispatch({ type: ACTION_TYPES.FETCH_PERF_GRID, payload: res.data });
    }
  );
};
export const createActionRail = (dispatch, data, tier) => {
  AsyncCallHandler(NEXUS_CONST.MANAGE_ACTIONS, NEXUS_CONST.POST, data).then(
    (res) => {
      fetchSitewiseRailGridData(dispatch, tier);
      //dispatch({ type: ACTION_TYPES.FETCH_PERF_GRID, payload: res.data });
    }
  );
};
export const deleteAction = (dispatch, id, tier) => {
  AsyncCallHandler(NEXUS_CONST.DELETE_ACTION + id, NEXUS_CONST.POST).then(
    (res) => {
      fetchRailGridData(dispatch, tier);
      //dispatch({ type: ACTION_TYPES.FETCH_PERF_GRID, payload: res.data });
    }
  );
};

export const fetchUsers = (dispatch, props) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_PEOPLE + props, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_PEOPLE, payload: res.data });
    }
  );
};

export const fetchMOCData = (dispatch, tier) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_MOC + tier, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_MOC, payload: res.data });
    }
  );
};

export const updateMOC = (dispatch, data, tier) => {
  AsyncCallHandler(NEXUS_CONST.UPDATE_MOC, NEXUS_CONST.POST, data).then(
    (res) => {
      fetchMOCData(dispatch, tier);
    }
  );
};

export const deleteMOC = (dispatch, id, tier) => {
  AsyncCallHandler(NEXUS_CONST.DELETE_MOC + id, NEXUS_CONST.POST).then(
    (res) => {
      fetchMOCData(dispatch, tier);
    }
  );
};

export const fetchGembaData = (dispatch, props) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_GEMBA + props, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_GEMBA, payload: res.data });
    }
  );
};

export const updateGemba = (dispatch, data, props) => {
  AsyncCallHandler(NEXUS_CONST.UPDATE_GEMBA, NEXUS_CONST.POST, data).then(
    (res) => {
      fetchGembaData(dispatch, props);
    }
  );
};

export const getMessages = (dispatch, props) => {
  AsyncCallHandler(NEXUS_CONST.GET_MESSAGES + props, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.GET_MESSAGES, payload: res.data });
    }
  );
};

export const updateMessages = (dispatch, data) => {
  AsyncCallHandler(NEXUS_CONST.UPDATE_MESSAGES, NEXUS_CONST.POST, data).then(
    (res) => {
      getMessages(
        dispatch,
        `siteId=${data.sitecode}&tierId=${data.tierid}&sqdcp=${data.sqdcp}&title=${data.safetymessage}`
      );
    }
  );
};

export const getAlerts = (dispatch, props) => {
  AsyncCallHandler(NEXUS_CONST.GET_ALERTS + props, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.GET_ALERTS, payload: res.data });
    }
  );
};

export const updateAlerts = (dispatch, data, props) => {
  AsyncCallHandler(NEXUS_CONST.UPDATE_ALERTS, NEXUS_CONST.PUT, data).then(
    (res) => {
      getAlerts(dispatch, props);
    }
  );
};

export const fetchReasonCodes = (dispatch, props) => {
  AsyncCallHandler(NEXUS_CONST.GET_REASON_CODES + props, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.GET_REASON_CODES, payload: res.data });
    }
  );
};

export const fetchDowntimeData = (dispatch, tier) => {
  AsyncCallHandler(NEXUS_CONST.GET_DOWNTIME + tier, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.GET_DOWNTIME, payload: res.data });
    }
  );
};

export const addDowntimeMetric = (dispatch, data, tier) => {
  AsyncCallHandler(
    NEXUS_CONST.ADD_DOWNTIME_METRIC,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    fetchDowntimeData(dispatch, tier);
  });
};

export const updateDowntimeMetric = (dispatch, data, tier) => {
  AsyncCallHandler(
    NEXUS_CONST.UPDATE_DOWNTIME_METRIC,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    fetchDowntimeData(dispatch, tier);
  });
};

export const deleteDowntimeMetric = (dispatch, metricId, tier) => {
  AsyncCallHandler(
    NEXUS_CONST.DELETE_DOWNTIME_METRIC + metricId,
    NEXUS_CONST.POST
  ).then((res) => {
    fetchDowntimeData(dispatch, tier);
  });
};

export const fetchCalendarPlan = (dispatch, props) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_CALENDAR_PLAN + props,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_CALENDAR_PLAN, payload: res.data });
  });
};

export const addCalendarPlan = (dispatch, data, props) => {
  AsyncCallHandler(NEXUS_CONST.ADD_CALENDAR_PLAN, NEXUS_CONST.POST, data).then(
    (res) => {
      fetchCalendarPlan(dispatch, props);
    }
  );
};

export const updateCalendarPlan = (dispatch, data, props) => {
  AsyncCallHandler(
    NEXUS_CONST.UPDATE_CALENDAR_PLAN,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    fetchCalendarPlan(dispatch, props);
  });
};

export const deleteCalendarPlan = (dispatch, id, props) => {
  AsyncCallHandler(
    NEXUS_CONST.DELETE_CALENDAR_PLAN + id,
    NEXUS_CONST.POST
  ).then((res) => {
    fetchCalendarPlan(dispatch, props);
  });
};

export const exportData = (url, name, inputData = null) => {
  AsyncCallHandler(url, NEXUS_CONST.POST, inputData, NEXUS_CONST.BLOB).then(
    (res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name + ".xlsx");
      document.body.appendChild(link);
      link.click();
    }
  );
};

export const fetchTiersList = (dispatch, siteId) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_TIER_LIST + siteId, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_TIER_LIST, payload: res.data });
    }
  );
};

export const fetchIncidentdata = (dispatch, tier) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_INCIDENT + tier, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_INCIDENT, payload: res.data });
    }
  );
};

export const updateIncident = (dispatch, data, tier) => {
  AsyncCallHandler(NEXUS_CONST.UPDATE_INCIDENT, NEXUS_CONST.POST, data).then(
    (res) => {
      fetchIncidentdata(dispatch, tier);
    }
  );
};

export const deleteIncident = (dispatch, id, tier) => {
  AsyncCallHandler(NEXUS_CONST.DELETE_INCIDENT + id, NEXUS_CONST.POST).then(
    (res) => {
      fetchIncidentdata(dispatch, tier);
    }
  );
};

export const fetchGembaTypes = (dispatch, siteId) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_GEMBA_TYPES + siteId,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_GEMBA_TYPES, payload: res.data });
  });
};

export const fetchIncidentTypeData = (dispatch, props) => {
  AsyncCallHandler(NEXUS_CONST.GET_INCIDENT_TYPE + props, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.GET_INCIDENT_TYPE, payload: res.data });
    }
  );
};

export const fetchCalendarEventTypes = (dispatch, siteId) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_CALENDAR_EVENT_TYPES + siteId,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_CALENDAR_EVENT_TYPES,
      payload: res.data,
    });
  });
};

export const doMail = (dispatch, data, props) => {
  AsyncCallHandler(NEXUS_CONST.SEND_MAIL, NEXUS_CONST.POST, data).then(
    (res) => {
      /*done('mail sent!');*/
    }
  );
};

export const getAllUsers = (dispatch) => {
  AsyncCallHandler("adminconsole/getalluserslist", NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_ALL_USERS, payload: res.data });
    }
  );
};

export const saveHtmlTpl = (dispatch, data) => {
  AsyncCallHandler(
    "digitaltier/saveLayoutAttachment",
    NEXUS_CONST.PUT,
    data
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.SAVE_HTML_TPL, payload: res.data });
  });
};

export const getSchedules = (dispatch) => {
  AsyncCallHandler("AdminConsole/GetMailScheduler", NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_SCHEDULES, payload: res.data });
    }
  );
};

export const getTZ = (dispatch) => {
  AsyncCallHandler("AdminConsole/GetTimeZoneList", NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_TZ, payload: res.data });
    }
  );
};

export const saveSchedule = (dispatch, data) => {
  AsyncCallHandler(
    "AdminConsole/ManageMailScheduler",
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    getSchedules(dispatch);
  });
};

export const delSchedule = (dispatch, id) => {
  AsyncCallHandler(
    "AdminConsole/deleteMailScheduler?id=" + id,
    NEXUS_CONST.POST
  ).then((res) => {
    getSchedules(dispatch);
  });
};

export const saveMassCommunication = (dispatch, data, done) => {
  AsyncCallHandler("Home/saveMassCommunication", NEXUS_CONST.POST, data).then(
    (res) => {
      if (res > 0) done("mail sent!");
    }
  );
};

export const fetchNominationData = (dispatch, props) => {
  AsyncCallHandler(NEXUS_CONST.GET_NOMINATION + props, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.GET_NOMINATION, payload: res.data });
    }
  );
};

export const manageNominationData = (dispatch, data) => {
  AsyncCallHandler(NEXUS_CONST.MANAGE_NOMINATION, NEXUS_CONST.POST, data).then(
    (res) => {
      fetchNominationData(dispatch, data.tierId);
    }
  );
};

export const manageRecognitionData = (dispatch, data) => {
  AsyncCallHandler(NEXUS_CONST.MANAGE_RECOGNITION, NEXUS_CONST.POST, data).then(
    (res) => {
      fetchNominationData(dispatch, data.tierId);
    }
  );
};

export const fetchHSECommunicationData = (dispatch, siteId, tierId) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_HSECOMMUNICATION + siteId + "&tierId=" + tierId,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_HSECOMMUNICATION, payload: res.data });
  });
};

export const updateHSECommunicationData = (dispatch, data, props) => {
  AsyncCallHandler(
    NEXUS_CONST.UPDATE_HSECOMMUNICATION,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    fetchHSECommunicationData(dispatch, data.SiteID, data.TierID);
  });
};

export const deleteFile = (data) => {
  AsyncCallHandler(
    "digitaltier/removeAttachedBlobFile?" + data,
    NEXUS_CONST.POST,
    null
  );
};

export const fetchUserPref = (dispatch, props) => {
  AsyncCallHandler(
    "Home/getGridCustomization?tierid" + props,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "USER_PREF", payload: res.data });
  });
};
export const updateUserPref = (dispatch, data) => {
  AsyncCallHandler("Home/ManageGridCustomData", NEXUS_CONST.POST, data).then(
    (res) => {
      //data saved!
    }
  );
};

export const fetchSmessCards = (dispatch, props) => {
  AsyncCallHandler(
    "SMESS/GetShiftwiseCardData?tierId=" + props,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "FECTH_SMESS_CARDS", payload: res.data });
  });
};

export const saveSmessCards = (dispatch, data, emailData) => {
  AsyncCallHandler(
    "SMESS/manageTierShiftAssessment",
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    //data saved!
    if (res.status === 200) {
      if (emailData.siteId != "BA_CT13") {
        sendSMESSemail(
          dispatch,
          emailData.siteId.split("_")[1],
          emailData.tierId,
          emailData.shiftNo,
          `Shift ${emailData.shiftNo}`
        );
      }
    }
  });
};

export const getGembaWalkPriorities = (dispatch, tierId) => {
  AsyncCallHandler(`SMESS/GetGembaWalkPrioritiesData?tierId=${tierId}`).then(
    (res) => {
      dispatch({
        type: ACTION_TYPES.GET_GEMBA_WALK_PRIORITIES_DATA,
        payload: res.data,
      });
    }
  );
};

export const sendSMESSemail = (
  dispatch,
  siteId,
  tierId,
  shiftId,
  shiftName
) => {
  AsyncCallHandler(
    `SMESS/sendSMESSemail?siteId=${siteId}&tierId=${tierId}&shiftId=${shiftId}&shiftName=${shiftName}`,
    NEXUS_CONST.GET
  ).then((res) => {
    //email trigger api called
  });
};

export const fetchMultiSurveyNameData = (dispatch, tierId) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_MULTI_SURVEY_NAME_DATA + tierId,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_MULTI_SURVEY_NAME_DATA,
      payload: res.data,
    });
  });
};

export const getTierInfo = (dispatch, prop) => {
  AsyncCallHandler(NEXUS_CONST.GET_TIER_INFO + prop, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.GET_TIER_INFO, payload: res.data });
    }
  );
};

export const getPeopleList = (dispatch, prop) => {
  AsyncCallHandler( 'digitaltier/GetUsersListData?' + prop, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: 'PPL_LIST_FROM_SITE', payload: res.data });
    }
  );
};


export const fetchHUsers = (dispatch, props) => {
//return AsyncCallHandler( 'Settings/getUsersBySearch?key=' + props, NEXUS_CONST.GET)
  let URL = `${window.ENV.SPA_AUTHORITY}${
    NEXUS_CONST.SEARCH_USER_IDENTITY
  }?query=${props}&projectId=${get("tenantId")}&type=USER`;
  return executeApiRequest({
    url: URL,
    method: "get",
    accessToken: get("accessToken"),
  })
};